<template>
    <div>
        <label class="form-label" v-if="config.label.length">{{ config.label }}</label>
        <input class="form-control" @keyup="keyUp($event.target.value)" v-bind="config">
    </div>
</template>

<script>
export default {
    name: "FInput",
    emits: ['update-value'],
    props: ['options', 'name'],
    data() {
        return {
            config: {
                value: '',
                label: '',
                required: false,
                name: 'input',
                placeholder: '',
                autocomplete: 'off',
                type: 'text',
            }
        }
    }, mounted() {
        this.config = Object.assign({}, this.config, this.options);
    }, methods: {
        keyUp(value) {
            this.config.value = value;
            this.$emit('update-value', value);
        }
    }
}
</script>

<style scoped>

</style>
